/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dictation_Error_No_SpeechInputs */

const en_dictation_error_no_speech = /** @type {(inputs: Dictation_Error_No_SpeechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No speech detected`)
};

const pt_br2_dictation_error_no_speech = /** @type {(inputs: Dictation_Error_No_SpeechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma fala detectada`)
};

/**
* | output |
* | --- |
* | "No speech detected" |
*
* @param {Dictation_Error_No_SpeechInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dictation_error_no_speech = /** @type {((inputs?: Dictation_Error_No_SpeechInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dictation_Error_No_SpeechInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dictation_error_no_speech(inputs)
	return pt_br2_dictation_error_no_speech(inputs)
});